import { gql } from "@apollo/client";

export const RemoveFileFromInstalledBaseNode = gql`
    mutation RemoveFileFromInstalledBaseNode ($installedBaseNodeFileId: ID!){
        removeFileFromInstalledBaseNode (installedBaseNodeFileId: $installedBaseNodeFileId) {
            success
            message
        }
    }
`;
